import {
  BenchmarkCompanySalaryRange,
  BenchmarkMatchResult,
} from 'modules/job_catalog/benchmark/types'
import { Salary } from 'modules/job_catalog/lib/salary'

export const toBenchmarkCompanySalaryRange = (
  salary?: Salary
): BenchmarkCompanySalaryRange | null => {
  if (!salary) return null

  return {
    currency: salary.currency,
    periodicity: salary.periodicity,
    gross: 'gross' in salary ? salary.gross : null,
    min: 'min' in salary ? salary.min : null,
    max: 'max' in salary ? salary.max : null,
  }
}

export const withCompanySalaryRange = (
  benchmark: BenchmarkMatchResult,
  salary?: Salary
): BenchmarkMatchResult => ({
  ...benchmark,
  companySalaryRange: toBenchmarkCompanySalaryRange(salary) ?? benchmark.companySalaryRange,
})
